import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { Button, NumeroVerde } from '@next-nx/shared-ui/atoms'
import styles from './ContattaciBox.module.sass'
import { getIcon } from '@next-nx/utils/icons'
import { useIsMobile, useTealium, useTrans } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import ArrowRight from '../../atoms/Icons/ArrowRight'

interface Props {
  item: MenuItemType
  numeroVerde?: boolean
  colorVariant?: '' | 'white'
  numeroVerdeNoBackground?: boolean
  numeroVerdeDescription?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  className?: string
}

const ContattaciBox = (props: Props) => {
  const {
    item = undefined,
    numeroVerde = false,
    numeroVerdeNoBackground = false,
    numeroVerdeDescription = '',
    colorVariant = '',
    onClick = () => undefined,
    className = '',
  } = props

  const icon = item?.style ? getIcon(item.style) : null
  const isMobile = useIsMobile()
  const t = useTrans()
  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type: string = '', interazione: string = '') => {
    const action_timestamp = getTimestamp()
    let dlObj = {}

    switch (interazione) {
      case 'contattaci':
        dlObj = {
          virtual: 'action',
          action_name: 'contattaci',
          action_tech: 'click',
          action_type: action_type.replace(/\’|\s+/g, '_').toLowerCase(),
          action_timestamp,
          action_effect: 'azioni_contatto',
        }
        break
      case 'richiesta_preventivo':
        dlObj = {
          virtual: 'action',
          action_name: 'richiesta_preventivo',
          action_tech: 'click',
          action_type: 'richiedi_preventivo',
          action_timestamp,
          action_effect: 'form_richiesta_preventivo_accesso',
        }
        break
      case 'area_riservata':
        dlObj = {
          virtual: 'action',
          action_name: 'area_riservata',
          action_tech: 'click',
          action_type: 'accedi',
          action_timestamp,
          action_effect: 'accesso_area_riservata',
        }
        break
      default:
        break
    }
    linkDataLayer(dlObj)
  }

  return item ? (
    <div
      className={`${styles.root} ${
        colorVariant ? styles[`root--${colorVariant}`] : ''
      } ${className}`}
    >
      {!!icon && <div className={styles.icon}>{icon}</div>}
      {!!item.name && <p className={styles.title}>{item.name}</p>}
      {!!item.description && (
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: item.description }}
        />
      )}
      {(numeroVerde || !!item.children?.edges?.length) && (
        <div className={styles.ctaBox}>
          {numeroVerde && (
            <div className={styles.numeroVerde}>
              <NumeroVerde
                phoneLabel={t('Numero Verde')}
                color={colorVariant}
                noBackground={numeroVerdeNoBackground}
                description={numeroVerdeDescription}
              />
            </div>
          )}
          {item.children?.edges
            ?.map((x) => x.node)
            .map((x, i) =>
              x.key === 'richiesta_preventivo' ? (
                <Button
                  key={x.pk}
                  onClick={(e) => {
                    onClick(e)
                    handleTracking('', 'richiesta_preventivo')
                    handleTracking(x.name, 'contattaci')
                  }}
                  label={x.name}
                  variant={i == 1 ? 'ghost' : 'primary'}
                  color={colorVariant === 'white' ? colorVariant : 'default'}
                  icon={i == 1 ? <ArrowRight /> : getIcon(x.style)}
                  iconPos={i == 1 ? 'right' : 'left'}
                  className={'form_richiesta_preventivo'.toHotjarFormat('{0}', isMobile)}
                />
              ) : (
                <Button
                  key={x.pk}
                  onClick={() => {
                    if (x.key === 'area_riservata') {
                      handleTracking('', 'area_riservata')
                    } else if (x.key === 'area_riservata_contattaci') {
                      handleTracking('', 'area_riservata')
                      handleTracking(x.name, 'contattaci')
                    } else {
                      handleTracking(x.name, 'contattaci')
                    }
                  }}
                  href={x.url}
                  label={x.name}
                  variant={i == 1 ? 'ghost' : 'primary'}
                  color={colorVariant === 'white' ? colorVariant : 'default'}
                  icon={i == 1 ? <ArrowRight /> : getIcon(x.style)}
                  iconPos={i == 1 ? 'right' : 'left'}
                  newPage={x.blank}
                />
              )
            )}
        </div>
      )}
    </div>
  ) : (
    <></>
  )
}

export default ContattaciBox
